export const POST_VIEW_PURCHASES = 7
